
// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import './participant-line.component.css';

import restService from '../../services/rest-service';
import leafletSrvc from '../../services/leaflet.service';

import AdressSelection from '../adressSelection/adress-selection.component';
import DropDownButton from '../common/drop-down-button';
import participantService from '../../services/participants.service';

var modeTransport = participantService.modeTransport.getTransportLib();

var styles={
    inputLikeStyle : {
        background: 'white',
        padding: '5px 7px',
        borderRadius: '4px',
        color: 'black',
        width: '100%',
        fontSize: '14px',
        border: '2px solid rgba(47, 165, 255,0)'
    }
}

var ParticipantLine = CreateReactClass({
    propTypes : {
        participantID : PropTypes.number,
        handleDelete : PropTypes.func,
        handleDrag :  PropTypes.func,
        watchChange :  PropTypes.func,
        errorHandler :  PropTypes.func,
        adress : PropTypes.string,
        clickToOpenAdressSearch : PropTypes.func,
        selectOnMap : PropTypes.func,
        timePickerIsOpen : PropTypes.func,
    },
    defaultProps : {
        participantID : -1,
        handleDelete : function(){},
        handleDrag : function(){},
        adress : ''
    },
    participant : {},
    getInitialState: function () {
        return {
            id: -1,
            adressInput : '',
            coord : null,
            adressList : [],
            transp : 0,
            adressSearchIsOpen : false,
            isError : false
        };
    },
    componentDidMount(){
        this.updateParticipantFromService();
    },
    componentWillReceiveProps(nextProps){
        this.updateParticipantFromService();
    },
    shouldComponentUpdate(nextProps, nextState) {

        if (
            nextState.adressInput !== this.state.adressInput ||
            nextState.transp !== this.state.transp ||
            nextState.isError !== this.state.isError ||
            nextState.adressSearchIsOpen !== this.state.adressSearchIsOpen
        ){
            return true;
        }

        return false;

    },
    updateParticipantFromService(){
        this.participant = participantService.participants.getParticipant(this.props.participantID);

        if (!this.participant){
            return ;
        }

        this.setState({
            id : this.participant.id,
            adressInput : this.participant.adress,
            coord : this.participant.coord,
            transp : this.participant.transp,
        });

    },
    onClickDelete : function(){
        var id  = this.state.id;
        this.props.handleDelete(id);
    },
    handleAdressChange: function(e){

        this.setState({
            adressInput : e.target.value,
            coord : null,
            isActive : true,
        });

        this.participant.coord = null;
        this.participant.adress = e.target.value;
        this.participant.valid = false;

        // console.log('delete coord for '  + this.participant.id + ' / ' + this.props.participantID );
        participantService.participants.modifyParticipant (this.participant);

        restService.getBanAdress(e.target.value)
            .then(function(res){
                this.setState({
                    adressList : res,
                });
            }.bind(this));

        leafletSrvc.unPlotParticipant(this.participant.id);
        this.props.watchChange(true)

    },
    onSelectAdress : function(item){

        leafletSrvc.unPlotParticipant(this.participant.id);


        this.setState({
            adressInput : item.lib,
            coord : null,
            isError : false
        });

        this.participant.coord = null;
        this.participant.adress = item.lib;
        this.participant.valid = false;

        restService.checklocationvalidity({lng : item.coord[0], lat : item.coord[1]})
            .then(function(res){

                if (res.valid){
                    this.setState({
                        coord : item.coord,
                    });

                    this.participant.coord = item.coord;
                    this.participant.valid = true;

                    participantService.participants.modifyParticipant (this.participant);

                    leafletSrvc.plotParticipant(this.participant.id, this.props.handleDrag)
                }
                else {
                    // Gestion erreur
                    participantService.participants.modifyParticipant (this.participant);
                    this.props.errorHandler("Oulala ! Seul l'Ile-de-France est pour l'instant prise en charge.");
                    this.setState({
                        isError : true
                    })
                }


            }.bind(this))
            .catch(function(err){
                participantService.participants.modifyParticipant (this.participant);
                this.props.errorHandler(null);
                this.setState({
                    isError : true
                })


            }.bind(this))
    },
    onSelectTransp : function(item){
        this.setState({
            transp : item.id
        });
        this.participant.transp = item.id;
        participantService.participants.modifyParticipant (this.participant);
        this.props.watchChange(true)
    },
    clickToOpenTimePicker : function(){
        this.props.timePickerIsOpen(true);
    },
    clickToOpenAdressSearch : function(value){

        var wait = null;
        if (value === undefined){
            this.setState({
                adressSearchIsOpen : true
            });
            wait = setTimeout(()=> this.props.timePickerIsOpen(false), 300 );
        }
        else {
            this.setState({
                adressSearchIsOpen : value
            });
            if (value){
                wait = setTimeout(()=> this.props.timePickerIsOpen(!value), 300 );
            }
        }
    },
    render: function () {

        return (
            <div className="participantLine ligneFlexStartCentered" >

                <DropDownButton listItem={modeTransport} onSelect={this.onSelectTransp} choiceId={this.state.transp} />

                <div className="adressInput flexComponentOne ligneFlexStartCentered" >

                    <div style={styles.inputLikeStyle} onClick={this.clickToOpenAdressSearch} className="ligneFlexCenterSpaceBetween">
                        {(this.state.adressInput) ? (
                            <div>{this.state.adressInput}</div>) :  (<div>Adresse</div>)
                        }

                        {(this.state.isError) ? (<div style={{paddingRight: 10, color : 'red'}}>
                            <span className="fa fa fa-bug fa-lg"></span>
                        </div>) :  false
                        }

                    </div>

                </div>

                <div className="iconeMinus flexComponentNone">
                    <span className="FaActiveToBlack fa fa-minus-circle fa-2x" onClick={this.onClickDelete}></span>
                </div>

                {(this.state.adressSearchIsOpen) ? (
                    <AdressSelection  clickToOpenTimePicker={this.clickToOpenTimePicker} closeAdressSelection={this.clickToOpenAdressSearch} selectOnMap={this.props.selectOnMap} initialAdress={this.state.adressInput} selectAdress={this.onSelectAdress} />) : false
                }

            </div>
        )
    }
});


module.exports = ParticipantLine;


// WEBPACK FOOTER //
// ./src/components/areaFinder/participant-line.component.js